import script from "./Calculadora-Envios.vue?vue&type=script&setup=true&lang=js"
export * from "./Calculadora-Envios.vue?vue&type=script&setup=true&lang=js"

import "./Calculadora-Envios.vue?vue&type=style&index=0&id=06a1ccff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4c70acdb4c746897c15f9d0e9400da56/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06a1ccff"]])

export default __exports__